export default __webpack_public_path__ + "static/media/sold_out.f7e4da98.png";